module.exports = "/lucky-balls/img/bigball/BigBall_004.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_004.png
// module id = 899
// module chunks = 0